import React from 'react';

function Apply(){

    return (
        <div 
            className={ 'hidden md:flex sticky float-right w-24 h-11 bottom-1/2 bg-[#E64534] cursor-pointer z-[5001] text-white p-2 justify-center items-center mr-[-32px] hover:underline' } 
            onClick={() => window.open("https://apply.myschooldc.dc.gov/","_blank")}>
            <div className='text-sm font-bold my-auto'>Apply Here</div>
        </div>
    );
}

export default Apply;